import React from 'react';
import { Link } from 'react-router-dom';
import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

function TabBar(){
  const adminLoginState = Number(localStorage.getItem('adminLoginState'));
  const [varAdminMenus] = useRecoilState(AdminMenus);

  const adminMenu= localStorage.getItem("menuAvailables");
  const menuArray = adminMenu.split(','); 
  //console.log('menuArray',menuArray);
  //const menuArray = ['1','1','1','1','1','1','1','1','1','1'];

  return(
    <div className="admin-top-menu">
      {adminLoginState === 0 ? null :
        <>
          {Number(menuArray[0])===1?<Link to="/Admin/BranchList" className={varAdminMenus.type==="BRANCH"?"selected":""}>센터관리</Link>:null}
          {Number(menuArray[1])===1?<Link to="/Admin/CourseList" className={varAdminMenus.type==="COURSE"?"selected":""}>수강관리</Link>:null}
          {Number(menuArray[2])===1?<Link to="/Admin/MemberList" className={varAdminMenus.type==="MEMBER"?"selected":""}>학부모/원생관리</Link>:null}
          {Number(menuArray[3])===1?<Link to="/Admin/AnalysisList" className={varAdminMenus.type==="ANALYSIS"?"selected":""}>발달분석 및 평가</Link>:null}
          {Number(menuArray[4])===1?<Link to="/Admin/CertificationList" className={varAdminMenus.type==="CERTIFICATION"?"selected":""}>수료증관리</Link>:null}
          {Number(menuArray[5])===1?<Link to="/Admin/PaymentList" className={varAdminMenus.type==="PAYMENT"?"selected":""}>결제관리</Link>:null}
          {Number(menuArray[6])===1?<Link to="/Admin/SalesList" className={varAdminMenus.type==="SALES"?"selected":""}>매출리포트</Link>:null}
          {Number(menuArray[7])===1?<Link to="/Admin/SettlementList" className={varAdminMenus.type==="SETTLEMENT"?"selected":""}>정산현황</Link>:null}
          {Number(menuArray[8])===1?<Link to="/Admin/FaqList" className={varAdminMenus.type==="ENVIRONMENT"?"selected":""}>설정</Link>:null}
          {Number(menuArray[9])===1?<Link to="/Admin/Business" className={varAdminMenus.type==="VARIABLES"?"selected":""}>변수설정</Link>:null}
        </>
      }
    </div>
  )
}

export default TabBar;



